import { useRecalculateChatWidgetPositionOnMounAndUnmount } from '@components/LazyChatWidget/hooks/useRecalculateChatWidgetPositionOnMounAndUnmount';
import { useMemo } from 'react';

interface Props {
  position: number;
  navigationSteps: number;
}

export default function ProgressBar({
  position,
  navigationSteps,
}: Props): JSX.Element {
  const progressWidthPercentage = useMemo(
    () => `${((position - 1) / (navigationSteps - 1)) * 100}%`,
    [position, navigationSteps],
  );

  useRecalculateChatWidgetPositionOnMounAndUnmount();

  return (
    <div className="h-1 flex-1 overflow-hidden rounded-md bg-[#CEE5EA]">
      <div
        className="h-full bg-[#178199]"
        style={{ width: progressWidthPercentage }}
      />
    </div>
  );
}
